import React, { Suspense } from 'react';
import PropTypes from 'prop-types';

const AsyncReactZiggeoPlayer = React.lazy(() =>
  import(/* webpackChunkName: "ReactZiggeo" */ './ReactZiggeoPlayer'),
);

const ZiggeoMediaPlayer = props => {
  const { token, apiKey, className } = props;

  const VIDEO_PROFILE = '_lessonly_video_profile';

  return (
    <Suspense fallback={null}>
      <AsyncReactZiggeoPlayer
        apiKey={apiKey}
        video={token}
        skipinitial={false}
        width="100%"
        height="100%"
        video-profile={VIDEO_PROFILE}
        theme="modern"
        themecolor="black"
        className={className}
      />
    </Suspense>
  );
};

ZiggeoMediaPlayer.propTypes = {
  token: PropTypes.string.isRequired,
  apiKey: PropTypes.string.isRequired,
};

export default ZiggeoMediaPlayer;
